const SocketEvent = {
  CONNECTED: 'socket-event-mc-socket-connected',
  CONNECTION_ERROR: 'socket-event-mc-socket-connection-error',
  MESSAGE_RECEIVED: 'socket-event-mc-socket-message',
  NO_LOCAL_CONNECTION_DATA: 'socket-event-mc-no-local-connection-data',
  OFFLINE: 'socket-event-offline',
  SUBSCRIBED: 'socket-event-mc-socket-subscribed',
  UNSUBSCRIBED: 'socket-event-mc-socket-unsubscribed',
  USER_IS_OFFLINE: 'socket-event-mc-socket-is-offline',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

export default SocketEvent;
